import { Location } from 'react-router-dom';

const checkRouteActive = (route: string, location: Location) => route === location.pathname;
export { checkRouteActive };
